import _ from 'underscore';
import chroma from 'chroma-js';

export function filterByLanguage(object, language, fallback) {
    return _.mapObject(object, (field) => {
        if (_.isObject(field)) {
            return field[language] || field[fallback || 'default']; // _.pick(field, state.contentLanguage, 'default')
        } else return field;
    });
}
export function capitalize(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
}
export function isEmptyObject(value) {
    if (_.isObject(value)) {
        return !_.any(value, function (value) {
            return value !== undefined;
        });
    }
}
export function projectBackground(bg) {
    // console.log("in projectBackground", bg)
    if (!bg) return;
    if (bg == 'default') {
        return "background-image:url('/img/project_background_default_grey.jpg');background-size:cover;background-repeat: no-repeat; background-position: center;";
    } else if (bg.type == 'gradient') {
        return gradientBackground(bg.value);
    } else if (bg.type == 'unsplash') {
        return `background-image:url(${bg.value.urls.regular});background-size:cover; background-repeat: no-repeat; background-position: center;`;
    } else if (bg.url) {
        return `background-image:url(${bg.url});background-size:cover;background-repeat: no-repeat; background-position: center;`;
    }
}
export function avatarStyle(user) {
    let userImage = '';
    if (user.image && user.image.url) {
        userImage = user.image.url;
    } else {
        userImage = user.avatar;
    }
    return `background-image:url(${userImage});background-size:cover;background-repeat: no-repeat; background-position: center; margin:0 auto; border-radius: 50%`;
}

export function luminance(color) {
    return chroma(color).luminance();
}

export function isLightColor(baseColor) {
    return luminance(baseColor) > 0.55;
}
export function gradientBackground(colors) {
    return `background: linear-gradient( 135deg, ${colors[0]} 10%, ${colors[1]} 100%)`;
}

export const validators = {
    email: new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),
    url: new RegExp(
        /^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i
    ),
    text: new RegExp(/^[a-zA-Z]+$/),
    isodate: new RegExp(
        /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/
    ),
};

export function getIDFromYoutubeURL(url) {
    const youtubeRegexp =
        /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi;
    let id = url.replace(youtubeRegexp, '$1');

    if (id.includes(';')) {
        const pieces = id.split(';');

        if (pieces[1].includes('%')) {
            const uriComponent = decodeURIComponent(pieces[1]);
            id = `http://youtube.com${uriComponent}`.replace(
                youtubeRegexp,
                '$1'
            );
        } else {
            id = pieces[0];
        }
    } else if (id.includes('#')) {
        id = id.split('#')[0];
    }
    return id;
}

export function sizeForHumans(bytes) {
    if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + 'GB';
    } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + 'MB';
    } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + 'KB';
    } else if (bytes > 1) {
        bytes = bytes + ' bytes';
    } else if (bytes == 1) {
        bytes = bytes + ' byte';
    } else {
        bytes = '0 bytes';
    }

    return bytes;
}

export function timeFormat(milis) {
    let ms = milis % 1000;
    milis = (milis - ms) / 1000;
    let seconds = milis % 60;
    milis = (milis - seconds) / 60;
    let minutes = milis % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}

export function cleanHTML(html) {
    return html.replace(/<\/?[^>]+>/gi, '');
}
